// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    COMPANY_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        companyIndexPage: action.companyIndexPage
      };
    },
    COMPANY_INDEX_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'most-innovative-companies',
        'categoryPage'
      );

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-innovative-companies';
      return {
        isLoading: false,
        data: action.companyIndexPage,
        ads: adModelData
      };
    },
    COMPANY_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
